// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__wA2Rc","footer":"ModalError_footer__25TIa"};